export const onboardingSections = {
    ACCEPT_SERVICE_AGREEMENT: {
        key: 1,
        heading: {
            title: "SingularityNet AI Publisher's Agreement",
            description: "Please review and agree to the terms to continue",
        },
    },
    SINGULARITY_ACCOUNT: {
        key: 2,
        heading: {
            title: "Let's Get Started",
            description: "Please, fill in all the fields below",
        },
    },
    ORGANIZATION: {
        key: 3,
        heading: {
            title: "Authenticate Organization",
            description: "Please provide your information",
        },
    },
    INVITEE: {
        key: 3,
        heading: {
            title: "Complete Registration",
            description: "Please provide your information",
        },
    },
};

export const progressText = [
    "Accept Service Agreement",
    "SingularityNet Account",
    "Authenticate ID",
];

export const organizationIdAvailability = {
    AVAILABLE: "AVAILABLE",
    UNAVAILABLE: "UNAVAILABLE",
};

export const orgVerificationStatus = {
    NOT_STARTED: undefined,
    PENDING: "PENDING",
    APPROVED: "APPROVED",
    REJECTED: "REJECTED",
    CHANGE_REQUESTED: "CHANGE_REQUESTED",
};

export const userPreferencesLocalStorageItem = "userPreferences";
export const INVITE_CODE_KEY = "invite_code";
